import React from 'react';

export default function SprintSectionHeader({ label, titlePrefix, highlightText, titleSuffix, subtitle, center, className = '' }) {
    return (
        <div className={`sprint-section-header sprint-reveal ${className}`}>
            {label && <span className={`sprint-section-label ${center ? 'center' : ''}`}>{label}</span>}
            <h2 className="sprint-section-title">
                {titlePrefix} {highlightText && <span className="highlight">{highlightText}</span>} {titleSuffix}
            </h2>
            {subtitle && <p className="sprint-section-subtitle">{subtitle}</p>}
        </div>
    );
}
